import Vue from 'vue';
import VueRouter from 'vue-router';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';

import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';

import 'flatpickr/dist/flatpickr.css';
import VueFlatPickr from 'vue-flatpickr-component';

import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';

import App from './App';
import store from './store';
import router from './routes';
import registerGlobals from './utils';

import genericMixin from './mixins/generic';

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueFlatPickr);
Vue.component('v-icon', Icon);
Vue.component('v-select', vSelect);

Vue.mixin(genericMixin);

registerGlobals(Vue);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
